/* eslint-disable jsx-a11y/label-has-associated-control */
import { StripeElementsContainer } from '@jotta/settings/StripeContainer'
import type { StripeValidationError } from '@jotta/ui/ChangePaymentMethodDialog'
import { StripeCardForm } from '@jotta/ui/ChangePaymentMethodDialog'
import { t, Trans } from '@lingui/macro'
import { useElements, useStripe } from '@stripe/react-stripe-js'
import Debug from 'debug'
import { useState } from 'react'
import { bizApi } from '../BizApi'
import { BizWidget } from '../widgets/BizWidget'
import { Link, useNavigate } from 'react-router-dom'
import { BizBoundary } from '../components/BizBoundary'
const debug = Debug('jotta:biz:payment')

export function BizChangePaymentInfoRoute() {
  const { data: config } = bizApi.config.get.useSuspenseQuery()
  const publicKey = config.brandingInfo?.stripePublicKey
  if (!publicKey) {
    throw new Error('Stripe public key not found')
  }
  debug('Stripe public key', publicKey)
  return (
    <BizWidget title={t`Change Payment Information`}>
      <BizBoundary hideErrorFooter>
        <StripeElementsContainer publicKey={publicKey}>
          <BizChangePaymentInfoForm />
        </StripeElementsContainer>
      </BizBoundary>
    </BizWidget>
  )
}
export function BizChangePaymentInfoForm() {
  const [errors, setErrors] = useState<StripeValidationError>({})
  const hasErrors = Object.values(errors).some(v => v !== undefined)
  const elements = useElements()
  const stripe = useStripe()
  const navigate = useNavigate()
  const mutation = bizApi.subscription.changePayment.useMutation({
    onSettled(data, error, variables, context) {
      if (error) {
        debug('Error changing payment method', error)
      } else {
        navigate('./accepted')
      }
    },
  })
  const { data: paymentInfo } =
    bizApi.subscription.getPaymentInfo.useSuspenseQuery()
  const paymentMethod = paymentInfo.paymentInfo?.paymentMethod
  const currentCreditCard =
    paymentMethod && paymentMethod.case === 'card' ? paymentMethod.value : null

  return (
    <>
      {mutation.isPending && <div className="loading loading-absolute" />}
      {currentCreditCard ? (
        <div className="pb-6">
          <h3 className="h4">
            <Trans>Current credit card:</Trans>
          </h3>
          <p>
            {currentCreditCard.cardVendor} {currentCreditCard.cardMask}
          </p>
        </div>
      ) : null}
      <div className="grid max-w-xl gap-4">
        <p>
          <Trans>
            Enter new credit card details in the box below. Your new credit card
            will be used for future renewals of your subscription.
          </Trans>
        </p>
        {stripe && elements ? (
          <StripeCardForm
            onVerify={cardNumberElement => {
              mutation.mutateAsync({ stripe, cardNumberElement })
            }}
            errors={errors}
            setErrors={setErrors}
          >
            <div className="col-span-full grid">
              <button
                type="submit"
                disabled={mutation.isPending || hasErrors}
                className="btn btn-primary"
              >
                <Trans>Save Card</Trans>
              </button>
              <Link to=".." className="link justify-self-center p-4">
                <Trans>Cancel</Trans>
              </Link>
            </div>
          </StripeCardForm>
        ) : (
          <div className="loading" />
        )}
      </div>
    </>
  )
}
